import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle, Loader2, MailCheck } from "lucide-react";
import { memberApi } from "../api/member";
import { pageRoutes } from "../utils";

export default function ConfirmEmailChange() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState(token ? "loading" : "error");
  const [message, setMessage] = useState(
    token ? "Confirming your email address..." : "This email change link is invalid or expired."
  );

  useEffect(() => {
    let cancelled = false;
    async function confirm() {
      if (!token) {
        return;
      }
      try {
        const payload = await memberApi("/api/auth/confirm-email-change", {
          method: "POST",
          body: JSON.stringify({ token }),
        });
        if (!cancelled) {
          setStatus("success");
          setMessage(payload.message || "Email address updated successfully.");
        }
      } catch (error) {
        if (!cancelled) {
          setStatus("error");
          setMessage(
            error instanceof Error
              ? error.message
              : "This email change link is invalid or expired."
          );
        }
      }
    }
    confirm();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FDF8F3] px-4 py-16">
      <div className="mx-auto max-w-md rounded-3xl border border-[#C9A227]/20 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-3">
          {status === "loading" ? (
            <Loader2 className="h-7 w-7 animate-spin text-[#722F37]" />
          ) : status === "success" ? (
            <MailCheck className="h-7 w-7 text-[#722F37]" />
          ) : (
            <AlertCircle className="h-7 w-7 text-red-700" />
          )}
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-[#A88520]">
              Email change
            </p>
            <h1 className="font-serif-elegant text-3xl font-bold text-[#722F37]">
              Confirm email address
            </h1>
          </div>
        </div>

        <div
          className={`mt-6 rounded-2xl border px-4 py-3 text-sm ${
            status === "success"
              ? "border-green-200 bg-green-50 text-green-900"
              : status === "loading"
              ? "border-[#C9A227]/30 bg-[#fff8ec] text-gray-800"
              : "border-red-200 bg-red-50 text-red-900"
          }`}
        >
          {message}
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm">
          <Link className="font-semibold text-[#722F37] underline" to={pageRoutes.MemberLogin}>
            Member login
          </Link>
          <Link className="font-semibold text-[#722F37] underline" to={pageRoutes.AdminLogin}>
            Admin login
          </Link>
        </div>
      </div>
    </div>
  );
}
